export default function () {
  switchName()

  const urlParams = new URLSearchParams(window.location.search)
  const discountCode = urlParams.get('aic')

  if (discountCode) {
    //Referral Candy prepends "FRIEND-" to discount code
    const prependedDiscountCode = 'FRIEND-' + discountCode

    // Save the discount code as a session cookie
    document.cookie = `discount_code=${prependedDiscountCode}; path=/`

    // Send GET request to "/discount/[discountcode]"
    fetch(`/discount/${prependedDiscountCode}`)
      .then(function () {
        // After the discount code has been applied, force the cart to update so the discount is visible for anything that calls the .cart.json file e.g. an AJAX draw cart.
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: {},
          }),
        })
      })
      .catch(function (error) {
        console.error('Error:', error)
      })
  }
}

function switchName() {
  const urlParams = new URLSearchParams(window.location.search)
  const name = urlParams.get('first_name')

  if (name) {
    const nameEl = document.querySelector('.HeroDiscount__title')
    if (nameEl && nameEl.textContent) {
      nameEl.textContent.replace('Your friend', name)
    }
  }
}
